import { styled } from "@mui/material/styles";
// import { rgba } from "polished";

export const Wrapper = styled("div")(({ theme }) => {
  return {};
});
